<template>
  <base-hover
    v-slot="{ isHover }"
    class="album-item hover clickable"
  >
    <div>
      <base-like-button
        v-if="canLike"
        :value="favorite"
        @click="onSingleClick"
        @input="onFavoriteChanged"
      />
      <transition
        v-if="canDelete && canHover"
        name="fade"
      >
        <base-icon
          v-show="isHover || isIPad"
          icon="cancel"
          class="p-2 button"
          @click="$emit('delete')"
        />
      </transition>
      <img
        v-multiclick
        v-srcset
        class="album-item__img"
        :src="img"
        :class="{'hovered': isHover && canDelete}"
        @single-click="onSingleClick"
        @double-click="onDoubleClick"
      >
      <base-icon v-if="isVid" class="play-icon" icon="play-button" />
    </div>
  </base-hover>
</template>
<script>
import whichbrowser from '@/components/mixins/whichbrowser';

export default {
  name: 'Item',
  mixins: [whichbrowser],
  props: {
    isVid: {
      type: Boolean,
      default: false,
    },
    src: {
      type: String,
      required: true,
    },
    canHover: {
      type: Boolean,
      default: false,
    },
    canDelete: {
      type: Boolean,
      default: false,
    },
    canLike: {
      type: Boolean,
      default: false,
    },
    linked: {
      type: Boolean,
      default: false,
    },
    liked: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    favorite: false,
  }),
  computed: {
    img() {
      return `${this.src}?h=220&w=240&fit=crop`;
    },
  },
  watch: {
    liked: {
      handler(newVal) {
        this.favorite = newVal;
      },
      immediate: true,
    },
  },
  methods: {
    onFavoriteChanged(value) {
      this.favorite = value;
      this.emitFavoriteChange();
    },
    emitFavoriteChange() {
      this.$emit(this.favorite ? 'like' : 'unlike');
    },
    onSingleClick() {
      this.$emit('selected-image');
    },
    onDoubleClick() {
      if (!this.canLike) return;
      this.onFavoriteChanged(true);
    },
  },
};
</script>
<style lang="scss"
  scoped>
.album-item {
  height: 220px;
  overflow: hidden;

  &__img {
    height: 220px;
    object-fit: cover;
    margin: 0 auto;
    display: block;
    transition: opacity .3s ease;
    cursor: pointer;
    width: 100%;

    &.hovered {
      opacity: 0.5;
    }
  }
}

.hover {
  position: relative;

  .base-icon.button {
    position: absolute;
    right: 1rem;
    top: 1rem;
    z-index: 1;
    border: 1px transparent solid;
    background-color: $gray-light;
    border-radius: 5px;
    cursor: pointer;
    transition: border-color .2s ease;

    &:hover {
      border-color: $gray;
    }
  }
}
.play-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity .2s ease, transform .2s ease !important;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
  {
  opacity: 0 !important;
  transform: translateY(-20%);
}
</style>
